/*
 *
 * ComboBox constants
 *
 */

export const LOAD_OPTIONS = 'claris-vnext/AdvancedForm/ComboBox/LOAD_OPTIONS';
